import React from "react";
import { Heart, Bell, ShieldAlert } from "lucide-react";

const MODES = [
    {
        id: "gentle",
        label: "Gentle",
        desc: "Soft taps, max 2 a day. Gives you space.",
        icon: Heart,
        color: "sage",
    },
    {
        id: "balanced",
        label: "Balanced",
        desc: "Friendly check-ins every couple of hours.",
        icon: Bell,
        color: "mustard",
    },
    {
        id: "accountability",
        label: "Accountability",
        desc: "Mochi nudges you about a specific task every 2 hours.",
        icon: ShieldAlert,
        color: "terracotta",
    },
];

// Gentle / Balanced / Accountability mode selector.
export default function NotificationModePicker({ value, onChange }) {
    return (
        <>
            <p className="font-body text-xs uppercase tracking-widest text-warm-500 mb-2">Notification mode</p>
            <div className="space-y-2">
                {MODES.map((m) => {
                    const sel = value === m.id;
                    const Icon = m.icon;
                    return (
                        <button
                            key={m.id}
                            onClick={() => onChange(m.id)}
                            className={`w-full text-left p-4 rounded-2xl flex items-start gap-3 transition-all border-2 ${
                                sel ? "bg-surface border-terracotta shadow-clay" : "bg-surface/50 border-transparent hover:bg-surface"
                            }`}
                            data-testid={`settings-mode-${m.id}`}
                        >
                            <div className={`w-10 h-10 rounded-full flex items-center justify-center shrink-0 ${
                                m.color === "sage" ? "bg-sage" : m.color === "mustard" ? "bg-mustard" : "bg-terracotta"
                            }`}>
                                <Icon size={18} className="text-cream" />
                            </div>
                            <div className="flex-1">
                                <p className="font-display text-warm-900 text-base">{m.label}</p>
                                <p className="font-body text-sm text-warm-500 mt-0.5">{m.desc}</p>
                            </div>
                            {sel && (
                                <span className="text-terracotta font-display text-xs uppercase tracking-widest mt-1">On</span>
                            )}
                        </button>
                    );
                })}
            </div>
        </>
    );
}
